import { type DicomMessage, DicomMessageLevel, type DicomSeries } from '@/lib/dicom/DicomSeries';
import type { DicomInfo } from '@/lib/dicom/DicomInfo';

/**
 * Message construction and series/file exclusion helpers shared by the DICOM
 * validation checks.
 */

/**
 * A unique and global counter to apply to new messages.
 */
let uniqueMessageId = 0;

export class DicomMessages {
    static makeMessage(level: DicomMessageLevel, message: string): DicomMessage {
        return {
            id: ++uniqueMessageId,
            level,
            message,
        };
    }

    static appendMessage(
        messages: DicomMessage[],
        level: DicomMessageLevel,
        message: string,
    ): void {
        messages.push(DicomMessages.makeMessage(level, message));
    }

    /**
     * Excludes a DicomSeries or DicomInfo, and appends a message (info by default).
     */
    static excludeWithMessage(
        dicomSeriesOrInfo: DicomSeries | DicomInfo,
        message: string,
        level = DicomMessageLevel.Info,
    ): void {
        if (!dicomSeriesOrInfo.isExcluded) {
            dicomSeriesOrInfo.isExcluded = true;
            DicomMessages.appendMessage(dicomSeriesOrInfo.messages, level, message);
        }
    }

    static excludeWithInfoMessage(
        dicomSeriesOrInfo: DicomSeries | DicomInfo,
        message: string,
    ): void {
        DicomMessages.excludeWithMessage(dicomSeriesOrInfo, message, DicomMessageLevel.Info);
    }

    static excludeWithWarningMessage(
        dicomSeriesOrInfo: DicomSeries | DicomInfo,
        message: string,
    ): void {
        DicomMessages.excludeWithMessage(dicomSeriesOrInfo, message, DicomMessageLevel.Warning);
    }

    static excludeWithErrorMessage(
        dicomSeriesOrInfo: DicomSeries | DicomInfo,
        message: string,
    ): void {
        DicomMessages.excludeWithMessage(dicomSeriesOrInfo, message, DicomMessageLevel.Error);
    }
}
